import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSGroupMode,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

interface DynamicMissionAddon {
  groups: string[];
  goal: number;
  progress: number;
}

export interface DynamicMission {
  [key: string]: {
    value: number;
    goal: number;
    progress: number;
    addons: DynamicMissionAddon[];
  };
}

export interface CMSGroupsConfig {
  groupsIncludeMode: CMSGroupMode;
  groupsInclude: string | null;
  groupsExcludeMode: CMSGroupMode;
  groupsExclude: string | null;
}

export interface MissionI extends CMSGroupsConfig {
  name: string;
  backendId?: string;
  description?: string;

  button1Text: string;
  button1Link: string;
  button2Text: string;
  button2Link: string;

  coinImage: CMSImageBase;
  prizeCp?: string;
  prizeFs?: string;

  realTimeProgress?: boolean;
}

export interface MissionBlockI extends CMSGroupsConfig {
  title: string;
  background: CMSImageBase;
  characters: CMSImageBase;
  missions: MissionI[];
  showVipLabel?: boolean;
  showGuestToggle?: boolean;
  onlyGuestAvailable?: boolean;
  identifier?: string;
}

export interface TermsLoyalty extends CMSGroupsConfig {
  id: number;
  title: string;
  description?: string;
  showGuestToggle?: boolean;
  onlyGuestAvailable?: boolean;
  identifier?: string;
}

export interface LoyaltyPageApi extends CMSApiBase {
  title: string;
  logo?: CMSImageBase;
  missionsBlocks?: MissionBlockI[];
  termsAndConditions: TermsLoyalty[];
}

export const loyaltyCMSV3 = (lang: string) =>
  request<LoyaltyPageApi>({
    url: buildCmsUrl({ path: 'loyalty', lang }),
  });

export const loyaltyCMSV4 = (lang: string) =>
  request<LoyaltyPageApi>({
    url: buildCmsUrl({
      path: 'loyalty',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<LoyaltyPageApi>
    ),
  });

export const loyaltyCMS = isCMSV3 ? loyaltyCMSV3 : loyaltyCMSV4;
